// extracted by mini-css-extract-plugin
module.exports =  {"legacyScroll":"nc1W0S2starhosmrGf0f","root":"cBKgOKLfVNHZ146aYSak"};